import { c as _c } from "react/compiler-runtime";
import type { SurveyHome } from '@/models/survey';
import type { SurveyTab } from '@/store/mainSlice';
import { CopySharingLink } from './CopySharingLink';
import { DeleteSurvey } from './DeleteSurvey';
import { DuplicateSurvey } from './DuplicateSurvey';
import { EditSurvey } from './EditSurvey';
import { PinSurvey } from './PinSurvey';
import { ShowPreview } from './ShowPreview';
import { ShowStatistics } from './ShowStatistics';
type ActionButtonsRenderCellProps = {
  setSurveyTab: (value: SurveyTab) => void;
} & SurveyHome;
export const ActionButtonsRenderCell = t0 => {
  const $ = _c(25);
  let row;
  let setSurveyTab;
  if ($[0] !== t0) {
    ({
      setSurveyTab,
      ...row
    } = t0);
    $[0] = t0;
    $[1] = row;
    $[2] = setSurveyTab;
  } else {
    row = $[1];
    setSurveyTab = $[2];
  }
  let t1;
  let t2;
  if ($[3] !== row) {
    t1 = <ShowPreview survey={row} />;
    t2 = <DuplicateSurvey survey={row} />;
    $[3] = row;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[6] !== row || $[7] !== setSurveyTab) {
    t3 = <EditSurvey survey={row} setSurveyTab={setSurveyTab} />;
    $[6] = row;
    $[7] = setSurveyTab;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  if ($[9] !== row) {
    t4 = <DeleteSurvey survey={row} />;
    t5 = <CopySharingLink survey={row} />;
    $[9] = row;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  let t6;
  if ($[12] !== row || $[13] !== setSurveyTab) {
    t6 = <ShowStatistics survey={row} setSurveyTab={setSurveyTab} />;
    $[12] = row;
    $[13] = setSurveyTab;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== row) {
    t7 = <PinSurvey survey={row} />;
    $[15] = row;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div className="flex items-center justify-end gap-1" onClick={_temp}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
function _temp(event) {
  return event.stopPropagation();
}